(function () {
  'use strict';

  /* ============================================================
     UTILITIES
  ============================================================ */
  function formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  function lockScroll()   { document.body.style.overflow = 'hidden'; }
  function unlockScroll() { document.body.style.overflow = ''; }

  /* ============================================================
     MODE (Day / Night)
  ============================================================ */
  var MODE_KEY = 'krauno-mode';

  function getMode() { return localStorage.getItem(MODE_KEY) || 'day'; }

  function applyMode(mode) {
    if (mode === 'night') {
      document.documentElement.classList.add('night-mode');
    } else {
      document.documentElement.classList.remove('night-mode');
    }
    localStorage.setItem(MODE_KEY, mode);
    updateModeUI(mode);
    closeHotspotDrawer();
  }

  function updateModeUI(mode) {
    document.querySelectorAll('[data-day-label],[data-night-label]').forEach(function (el) {
      el.textContent = mode === 'night'
        ? (el.dataset.nightLabel || el.dataset.dayLabel)
        : el.dataset.dayLabel;
    });
    resetCarouselDots();
  }

  /* ============================================================
     HEADER: scroll effect
  ============================================================ */
  function initHeader() {
    var header = document.getElementById('krauno-header');
    if (!header) return;
    window.addEventListener('scroll', function () {
      header.classList.toggle('scrolled', window.scrollY > 20);
    }, { passive: true });
  }

  /* ============================================================
     MOBILE MENU
  ============================================================ */
  function initMobileMenu() {
    var btn  = document.getElementById('k-menu-btn');
    var menu = document.getElementById('k-mobile-menu');
    if (!btn || !menu) return;

    btn.addEventListener('click', function () {
      var open = menu.classList.toggle('open');
      btn.classList.toggle('open', open);
      btn.setAttribute('aria-expanded', open);
    });

    menu.querySelectorAll('a').forEach(function (a) {
      a.addEventListener('click', function () {
        menu.classList.remove('open');
        btn.classList.remove('open');
        btn.setAttribute('aria-expanded', 'false');
      });
    });
  }

  /* ============================================================
     MOBILE MENU — COLLAPSIBLE SUB-ITEMS
     Each .k-mobile-sub starts hidden; the chevron button alongside
     the parent link toggles it open/closed.
  ============================================================ */
  function initMobileSubmenus() {
    document.querySelectorAll('.k-mobile-sub-toggle').forEach(function (btn) {
      var row = btn.closest('.k-mobile-nav-row');
      if (!row) return;
      var sub = row.nextElementSibling;
      if (!sub || !sub.classList.contains('k-mobile-sub')) return;

      btn.addEventListener('click', function () {
        var isOpen = sub.classList.toggle('open');
        btn.classList.toggle('open', isOpen);
        btn.setAttribute('aria-expanded', String(isOpen));
        sub.setAttribute('aria-hidden', String(!isOpen));
      });
    });
  }

  /* ============================================================
     DROPDOWN NAVIGATION
     JS-driven hover with a small close-delay so the gap between
     the nav link and the dropdown panel doesn't kill the state.
  ============================================================ */
  function initDropdowns() {
    // :not([data-dd-init]) prevents duplicate listeners when called on section:load
    document.querySelectorAll('.k-nav-item.has-dropdown:not([data-dd-init])').forEach(function (item) {
      item.setAttribute('data-dd-init', '1');
      var dropdown = item.querySelector('.k-dropdown');
      if (!dropdown) return;
      var closeTimer;

      function open() {
        clearTimeout(closeTimer);
        item.classList.add('is-open');
      }
      function scheduledClose() {
        closeTimer = setTimeout(function () { item.classList.remove('is-open'); }, 120);
      }

      item.addEventListener('mouseenter', open);
      item.addEventListener('mouseleave', scheduledClose);

      // Keyboard: open on focus of the parent link
      var link = item.querySelector('.k-nav-link');
      if (link) {
        link.addEventListener('focus', open);
        link.addEventListener('blur', function () {
          // Delay to allow focus to move inside the dropdown
          setTimeout(function () {
            if (!item.querySelector(':focus')) item.classList.remove('is-open');
          }, 150);
        });
      }

      // Close when clicking outside
      document.addEventListener('click', function (e) {
        if (!item.contains(e.target)) item.classList.remove('is-open');
      });
    });
  }

  /* ============================================================
     MODE TOGGLE BUTTON
  ============================================================ */
  function initModeToggle() {
    var btn = document.getElementById('k-mode-toggle');
    if (!btn) return;
    btn.addEventListener('click', function () {
      applyMode(getMode() === 'day' ? 'night' : 'day');
    });
  }

  /* ============================================================
     SCROLL ANIMATIONS (Intersection Observer)
  ============================================================ */
  function makeAllVisible() {
    document.querySelectorAll('.k-product-card, .k-stat-card, .k-trust-item, .k-room-canvas').forEach(function (el) {
      el.classList.add('visible');
    });
  }

  function initScrollAnimations() {
    if (window.Shopify && Shopify.designMode) {
      makeAllVisible();
      return;
    }

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        var delay = parseFloat(e.target.dataset.animDelay || 0) * 1000;
        setTimeout(function () { e.target.classList.add('visible'); }, delay);
        io.unobserve(e.target);
      });
    }, { threshold: 0.05, rootMargin: '60px 0px' });

    document.querySelectorAll('.k-product-card').forEach(function (el, i) {
      el.dataset.animDelay = (i % 3) * 0.1;
      io.observe(el);
    });
    document.querySelectorAll('.k-stat-card, .k-trust-item, .k-room-canvas').forEach(function (el) {
      io.observe(el);
    });
  }

  /* ============================================================
     STAT COUNTER ANIMATION
  ============================================================ */
  function initStatsCounters() {
    var els = document.querySelectorAll('[data-count-to]');
    if (!els.length) return;

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        animateCount(e.target);
        io.unobserve(e.target);
      });
    }, { threshold: 0.3 });

    els.forEach(function (el) { io.observe(el); });
  }

  function animateCount(el) {
    var target   = parseInt(el.dataset.countTo, 10);
    var duration = 2000;
    var steps    = 60;
    var step     = 0;
    var t = setInterval(function () {
      step++;
      if (step >= steps) { el.textContent = target; clearInterval(t); }
      else                { el.textContent = Math.round((target / steps) * step); }
    }, duration / steps);
  }

  /* ============================================================
     INTERACTIVE ROOM HOTSPOTS
  ============================================================ */
  var activeHotspot = null;

  function isMobile() { return window.innerWidth < 768; }

  function closeHotspotDrawer() {
    var drawer   = document.getElementById('k-hs-drawer');
    var backdrop = document.getElementById('k-hs-backdrop');
    var modal    = document.getElementById('k-mob-modal');
    if (drawer)   drawer.classList.remove('open');
    if (backdrop) backdrop.classList.remove('open');
    if (modal && modal.classList.contains('open')) {
      modal.classList.remove('open');
      modal.setAttribute('aria-hidden', 'true');
      unlockScroll();
    }
    if (activeHotspot) { activeHotspot.classList.remove('active'); activeHotspot = null; }
  }

  function openMobileModal(hotspot) {
    var modal = document.getElementById('k-mob-modal');
    if (!modal) return;

    var nameEl  = modal.querySelector('[data-mob-name]');
    var priceEl = modal.querySelector('[data-mob-price]');
    var descEl  = modal.querySelector('[data-mob-desc]');
    var linkEl  = modal.querySelector('[data-mob-link]');
    var img     = modal.querySelector('.k-mob-modal-img');
    var ph      = modal.querySelector('.k-mob-modal-img-ph');

    if (nameEl)  nameEl.textContent  = hotspot.dataset.name  || '';
    if (priceEl) priceEl.textContent = hotspot.dataset.price || '';
    if (descEl)  descEl.textContent  = hotspot.dataset.desc  || '';

    if (linkEl) {
      linkEl.href = hotspot.dataset.productUrl || '#';
      var labelEl = linkEl.querySelector('.k-mob-modal-btn-label');
      if (labelEl) labelEl.textContent = hotspot.dataset.btnText || 'View Product';
    }

    var hasImg = !!(hotspot.dataset.img && hotspot.dataset.img.trim().length > 0);
    if (img) {
      img.src           = hotspot.dataset.img || '';
      img.alt           = hotspot.dataset.name || '';
      img.style.display = hasImg ? '' : 'none';
    }
    if (ph) ph.style.display = hasImg ? 'none' : '';

    modal.classList.add('open');
    modal.setAttribute('aria-hidden', 'false');
    lockScroll();
  }

  function initHotspots() {
    var drawer   = document.getElementById('k-hs-drawer');
    var closeBtn = document.getElementById('k-hs-close');
    var backdrop = document.getElementById('k-hs-backdrop');
    var mobModal = document.getElementById('k-mob-modal');
    var mobClose = document.getElementById('k-mob-modal-close');
    var mobBd    = document.getElementById('k-mob-modal-bd');

    if (backdrop) backdrop.addEventListener('click', closeHotspotDrawer);
    if (mobClose) mobClose.addEventListener('click', closeHotspotDrawer);
    if (mobBd)    mobBd.addEventListener('click', closeHotspotDrawer);

    document.querySelectorAll('.k-hotspot').forEach(function (hotspot) {
      var btn = hotspot.querySelector('.k-hs-btn');
      if (!btn) return;

      btn.addEventListener('click', function (e) {
        e.stopPropagation();
        if (activeHotspot === hotspot) { closeHotspotDrawer(); return; }
        if (activeHotspot) activeHotspot.classList.remove('active');
        hotspot.classList.add('active');
        activeHotspot = hotspot;

        if (isMobile()) {
          openMobileModal(hotspot);
          return;
        }

        if (!drawer) return;

        // Text fields
        var nameEl  = drawer.querySelector('[data-hs-name]');
        var descEl  = drawer.querySelector('[data-hs-desc]');
        var priceEl = drawer.querySelector('[data-hs-price]');
        if (nameEl)  nameEl.textContent  = hotspot.dataset.name  || '';
        if (descEl)  descEl.textContent  = hotspot.dataset.desc  || '';
        if (priceEl) priceEl.textContent = hotspot.dataset.price || '';

        // Large product image + placeholder visibility
        var img         = drawer.querySelector('.k-hs-img');
        var placeholder = drawer.querySelector('.k-hs-img-placeholder');
        var hasImg      = !!(hotspot.dataset.img && hotspot.dataset.img.trim().length > 0);
        if (img) {
          img.src           = hotspot.dataset.img || '';
          img.alt           = hotspot.dataset.name || '';
          img.style.display = hasImg ? '' : 'none';
        }
        if (placeholder) placeholder.style.display = hasImg ? 'none' : '';

        // View product link + customisable button label
        var viewLink = drawer.querySelector('[data-hs-link]');
        if (viewLink) {
          viewLink.href = hotspot.dataset.productUrl || '#';
          var labelEl = viewLink.querySelector('.k-hs-btn-label');
          if (labelEl) labelEl.textContent = hotspot.dataset.btnText || 'View Product';
        }

        drawer.classList.add('open');
        if (backdrop) backdrop.classList.add('open');
      });
    });

    if (closeBtn) closeBtn.addEventListener('click', closeHotspotDrawer);
    document.addEventListener('click', function (e) {
      if (!drawer || !drawer.classList.contains('open')) return;
      if (activeHotspot && activeHotspot.contains(e.target)) return;
      if (drawer.contains(e.target)) return;
      closeHotspotDrawer();
    });
  }

  /* ============================================================
     MOBILE CAROUSEL DOTS
  ============================================================ */
  function resetCarouselDots() {
    document.querySelectorAll('.k-carousel-dots .k-dot').forEach(function (d, i) {
      d.classList.toggle('active', i === 0);
    });
  }

  function initCarouselDots() {
    document.querySelectorAll('.k-product-scroll').forEach(function (scroll) {
      var set  = scroll.closest('.k-products-set');
      var dots = set ? set.querySelectorAll('.k-dot') : [];
      scroll.addEventListener('scroll', function () {
        var idx = Math.round(scroll.scrollLeft / (280 + 16));
        dots.forEach(function (d, i) { d.classList.toggle('active', i === idx); });
      }, { passive: true });
      if (dots[0]) dots[0].classList.add('active');
    });
  }

  /* ============================================================
     SCROLL TO SECTION (Hero CTA)
  ============================================================ */
  function initHeroCTA() {
    document.querySelectorAll('[data-scroll-to]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var target = document.getElementById(btn.dataset.scrollTo);
        if (target) target.scrollIntoView({ behavior: 'smooth' });
      });
    });
  }

  /* ============================================================
     SEARCH MODAL
  ============================================================ */
  function initSearch() {
    var modal    = document.getElementById('k-search-modal');
    var input    = document.getElementById('k-search-input');
    var results  = document.getElementById('k-search-results');
    var openBtn  = document.getElementById('k-search-btn');
    var closeBtn = document.getElementById('k-search-close');
    var backdrop = document.getElementById('k-search-backdrop');

    if (!modal || !openBtn) return;

    var searchTimer;

    function openSearch() {
      modal.classList.add('open');
      modal.setAttribute('aria-hidden', 'false');
      lockScroll();
      setTimeout(function () { if (input) input.focus(); }, 80);
    }

    function closeSearch() {
      modal.classList.remove('open');
      modal.setAttribute('aria-hidden', 'true');
      unlockScroll();
      if (results) { results.innerHTML = ''; results.classList.remove('has-results'); }
      if (input)   { input.value = ''; }
    }

    openBtn.addEventListener('click', openSearch);
    if (closeBtn) closeBtn.addEventListener('click', closeSearch);
    if (backdrop) backdrop.addEventListener('click', closeSearch);

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && modal.classList.contains('open')) closeSearch();
    });

    if (input && results) {
      input.addEventListener('input', function () {
        clearTimeout(searchTimer);
        var q = input.value.trim();
        if (q.length < 2) {
          results.innerHTML = '';
          results.classList.remove('has-results');
          return;
        }
        searchTimer = setTimeout(function () { runSearch(q); }, 280);
      });
    }

    function runSearch(q) {
      var url = '/search/suggest.json?q=' + encodeURIComponent(q)
              + '&resources[type]=product&resources[limit]=7';
      fetch(url)
        .then(function (r) { return r.json(); })
        .then(function (data) {
          var products = (data.resources && data.resources.results && data.resources.results.products) || [];
          renderSearchResults(products, q);
        })
        .catch(function () {
          results.innerHTML = '<div class="k-search-msg">Something went wrong — please try again.</div>';
          results.classList.add('has-results');
        });
    }

    function renderSearchResults(products, q) {
      if (!products.length) {
        results.innerHTML = '<div class="k-search-msg">No products found for "<strong>' + escHtml(q) + '</strong>"</div>';
        results.classList.add('has-results');
        return;
      }
      var html = products.map(function (p) {
        var imgUrl = p.featured_image && p.featured_image.url ? p.featured_image.url : '';
        var imgHtml = imgUrl
          ? '<img src="' + escHtml(imgUrl) + '" alt="' + escHtml(p.title || '') + '" loading="lazy">'
          : '';
        var price = p.price ? formatMoney(p.price) : '';
        return '<a href="' + escHtml(p.url || '/') + '" class="k-search-result-item">'
          + '<div class="k-search-result-img">' + imgHtml + '</div>'
          + '<div>'
          +   '<div class="k-search-result-name">'  + escHtml(p.title || '') + '</div>'
          +   (price ? '<div class="k-search-result-price">' + price + '</div>' : '')
          + '</div>'
          + '</a>';
      }).join('');
      results.innerHTML = html;
      results.classList.add('has-results');
    }
  }

  /* ============================================================
     ACCOUNT PANEL
  ============================================================ */
  function initAccountPanel() {
    var panel    = document.getElementById('k-account-panel');
    var openBtn  = document.getElementById('k-account-btn');
    var closeBtn = document.getElementById('k-account-close');
    var backdrop = document.getElementById('k-account-backdrop');

    if (!panel || !openBtn) return;

    function openPanel() {
      panel.classList.add('open');
      panel.setAttribute('aria-hidden', 'false');
      lockScroll();
    }
    function closePanel() {
      panel.classList.remove('open');
      panel.setAttribute('aria-hidden', 'true');
      unlockScroll();
    }

    openBtn.addEventListener('click', openPanel);
    if (closeBtn) closeBtn.addEventListener('click', closePanel);
    if (backdrop) backdrop.addEventListener('click', closePanel);
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && panel.classList.contains('open')) closePanel();
    });
  }

  /* ============================================================
     CART DRAWER
  ============================================================ */
  function initCartDrawer() {
    var drawer   = document.getElementById('k-cart-drawer');
    var openBtn  = document.getElementById('k-cart-btn');
    var closeBtn = document.getElementById('k-cart-close');
    var backdrop = document.getElementById('k-cart-backdrop');
    var body     = document.getElementById('k-cart-body');
    var totalEl  = document.getElementById('k-cart-total-amount');
    var footer   = document.getElementById('k-cart-footer');

    if (!drawer) return;

    function openDrawer() {
      renderCart();
      drawer.classList.add('open');
      drawer.setAttribute('aria-hidden', 'false');
      lockScroll();
    }
    function closeDrawer() {
      drawer.classList.remove('open');
      drawer.setAttribute('aria-hidden', 'true');
      unlockScroll();
    }

    if (openBtn) openBtn.addEventListener('click', openDrawer);
    if (closeBtn) closeBtn.addEventListener('click', closeDrawer);
    if (backdrop) backdrop.addEventListener('click', closeDrawer);
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && drawer.classList.contains('open')) closeDrawer();
    });

    function renderCart() {
      if (!body) return;
      body.innerHTML = '<div class="k-cart-loading">Loading…</div>';

      fetch('/cart.js')
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          updateCartBadge(cart.item_count);
          if (totalEl) totalEl.textContent = formatMoney(cart.total_price);

          if (footer) {
            footer.style.display = cart.items && cart.items.length ? '' : 'none';
          }

          if (!cart.items || !cart.items.length) {
            body.innerHTML =
              '<div class="k-cart-empty">'
              + '<svg width="48" height="48" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="1.5" aria-hidden="true">'
              +   '<path stroke-linecap="round" stroke-linejoin="round" d="M16 11V7a4 4 0 00-8 0v4M5 9h14l1 12H4L5 9z"/>'
              + '</svg>'
              + '<p class="k-cart-empty-title">Your cart is empty</p>'
              + '<span class="k-cart-empty-sub">Add some items to get started</span>'
              + '</div>';
            return;
          }

          body.innerHTML = cart.items.map(function (item) {
            var imgHtml = item.featured_image
              ? '<img src="' + escHtml(item.featured_image.url) + '" alt="' + escHtml(item.title || '') + '" loading="lazy">'
              : '';
            var variant = (item.variant_title && item.variant_title !== 'Default Title') ? item.variant_title : '';
            return '<div class="k-cart-item" data-key="' + escHtml(item.key) + '">'
              + '<div class="k-cart-item-img">' + imgHtml + '</div>'
              + '<div class="k-cart-item-body">'
              +   '<div class="k-cart-item-name">' + escHtml(item.product_title || item.title || '') + '</div>'
              +   (variant ? '<div class="k-cart-item-variant">' + escHtml(variant) + '</div>' : '')
              +   '<div class="k-cart-item-row">'
              +     '<span class="k-cart-item-price">' + formatMoney(item.line_price) + '</span>'
              +     '<div class="k-qty-control">'
              +       '<button class="k-qty-btn" data-key="' + escHtml(item.key) + '" data-qty="' + (item.quantity - 1) + '" type="button" aria-label="Decrease quantity">−</button>'
              +       '<span class="k-qty-val">' + item.quantity + '</span>'
              +       '<button class="k-qty-btn" data-key="' + escHtml(item.key) + '" data-qty="' + (item.quantity + 1) + '" type="button" aria-label="Increase quantity">+</button>'
              +     '</div>'
              +   '</div>'
              +   '<button class="k-cart-remove" data-key="' + escHtml(item.key) + '" data-qty="0" type="button">Remove</button>'
              + '</div>'
              + '</div>';
          }).join('');
        })
        .catch(function () {
          if (body) body.innerHTML = '<div class="k-cart-loading">Could not load cart.</div>';
        });
    }

    // Qty + remove (event delegation on body)
    if (body) {
      body.addEventListener('click', function (e) {
        var btn = e.target.closest('[data-qty]');
        if (!btn) return;
        var key = btn.dataset.key;
        var qty = parseInt(btn.dataset.qty, 10);
        changeCartItem(key, qty, renderCart);
      });
    }

    // Expose so initCart can refresh drawer after add-to-cart
    window._kraunoRenderCart = renderCart;

    // Initial badge sync
    refreshCartBadge();
  }

  function changeCartItem(key, qty, cb) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ id: key, quantity: qty })
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        updateCartBadge(cart.item_count);
        if (cb) cb();
      })
      .catch(function () {});
  }

  function updateCartBadge(count) {
    var badge = document.getElementById('k-cart-count');
    if (!badge) return;
    badge.textContent = count;
    badge.classList.toggle('has-items', count > 0);
  }

  function refreshCartBadge() {
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) { updateCartBadge(cart.item_count); })
      .catch(function () {});
  }

  /* ============================================================
     ADD TO CART (AJAX)
  ============================================================ */
  function initAddToCart() {
    refreshCartBadge();

    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-add-to-cart]');
      if (!btn) return;

      var variantId = btn.dataset.variantId;
      if (!variantId) {
        var productUrl = btn.dataset.productUrl;
        if (productUrl) window.location.href = productUrl;
        return;
      }

      var label = btn.innerHTML;
      btn.disabled = true;
      btn.textContent = 'Adding…';

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({ id: parseInt(variantId, 10), quantity: 1 })
      })
        .then(function (r) { return r.json(); })
        .then(function () {
          btn.textContent = 'Added ✓';
          refreshCartBadge();
          // Refresh the cart drawer contents if it's open
          if (window._kraunoRenderCart) window._kraunoRenderCart();
          setTimeout(function () { btn.innerHTML = label; btn.disabled = false; }, 2000);
        })
        .catch(function () { btn.innerHTML = label; btn.disabled = false; });
    });
  }

  /* ============================================================
     HTML ESCAPE HELPER
  ============================================================ */
  function escHtml(str) {
    return String(str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  /* ============================================================
     PRODUCT CATALOG — featured card + carousel navigation
     direction: 1 = forward (next/right), -1 = backward (prev/left), 0 = no animation
  ============================================================ */
  function initProductCatalogs() {
    document.querySelectorAll('[data-catalog]').forEach(function (wrap) {
      if (wrap.dataset.catalogInit) return;
      wrap.dataset.catalogInit = '1';

      var featAnchor = wrap.querySelector('[data-feat-anchor]');
      var featImg    = wrap.querySelector('[data-feat-img]');
      var featName   = wrap.querySelector('[data-feat-name]');
      var featPrice  = wrap.querySelector('[data-feat-price]');
      var featInfo   = wrap.querySelector('[data-feat-info]');
      var fill       = wrap.querySelector('.k-catalog-prog-fill');
      var cards      = wrap.querySelectorAll('.k-catalog-sm-card');
      var prevBtn    = wrap.querySelector('.k-catalog-prev');
      var nextBtn    = wrap.querySelector('.k-catalog-next');
      var total      = cards.length;
      var current    = 0;

      if (!total) return;

      /* ── Show 3 right-panel cards immediately after current, with optional slide ── */
      function showRightCards(direction) {
        if (window.innerWidth < 768) return; // mobile: CSS handles all cards
        cards.forEach(function (card, i) {
          var pos = i - current - 1; // 0 = next after featured, 1 = +2, 2 = +3
          if (pos >= 0 && pos < 3) {
            card.style.display = 'flex';
            card.style.order   = String(pos);
            if (direction !== 0) {
              // Restart CSS animation with staggered delay
              card.classList.remove('slide-from-right', 'slide-from-left');
              card.style.animationDelay = (pos * 60) + 'ms';
              void card.offsetWidth; // force reflow
              card.classList.add(direction > 0 ? 'slide-from-right' : 'slide-from-left');
            }
          } else {
            card.style.display = 'none';
            card.style.order   = '';
            card.classList.remove('slide-from-right', 'slide-from-left');
            card.style.animationDelay = '';
          }
        });
      }

      /* ── Update featured image + overlay with directional swap animation ── */
      function updateFeatured(idx, direction) {
        var src   = cards[idx] ? cards[idx].dataset.img   || '' : '';
        var name  = cards[idx] ? cards[idx].dataset.name  || '' : '';
        var price = cards[idx] ? cards[idx].dataset.price || '' : '';
        var url   = cards[idx] ? cards[idx].dataset.url   || '#' : '#';

        // direction=0: initial render — set content directly, no animation
        if (direction === 0) {
          if (featImg) {
            if (src) { featImg.src = src; featImg.alt = name; featImg.style.display = ''; }
            else { featImg.style.display = 'none'; }
          }
          if (featName)   featName.textContent  = name;
          if (featPrice)  featPrice.textContent  = price;
          if (featAnchor) featAnchor.href        = url;
          return;
        }

        // Directional swap:
        //   next (dir=1) → carousel scrolls right → featured enters from LEFT  (enterX = -20)
        //   prev (dir=-1) → carousel scrolls left → featured enters from RIGHT (enterX = +20)
        var exitX  =  direction * 20;  // image/text exits toward the travel direction
        var enterX = -direction * 20;  // new content enters from the opposite side

        // Phase 1 — slide out current content
        if (featImg) {
          featImg.style.transition = 'opacity .18s ease';
          featImg.style.opacity    = '0';
        }
        if (featInfo) {
          featInfo.style.transition = 'opacity .18s ease, transform .18s ease';
          featInfo.style.opacity    = '0';
          featInfo.style.transform  = 'translateX(' + exitX + 'px)';
        }

        setTimeout(function () {
          // Swap content
          if (featImg) {
            if (src) { featImg.src = src; featImg.alt = name; featImg.style.display = ''; }
            else { featImg.style.display = 'none'; }
          }
          if (featName)   featName.textContent  = name;
          if (featPrice)  featPrice.textContent  = price;
          if (featAnchor) featAnchor.href        = url;

          // Snap to entry origin (no transition)
          if (featImg)  { featImg.style.transition = 'none'; }
          if (featInfo) {
            featInfo.style.transition = 'none';
            featInfo.style.opacity    = '0';
            featInfo.style.transform  = 'translateX(' + enterX + 'px)';
          }
          // Force reflow so the snap registers before we animate in
          if (featImg)  void featImg.offsetWidth;
          if (featInfo) void featInfo.offsetWidth;

          // Phase 2 — slide in new content
          if (featImg) {
            featImg.style.transition = 'opacity .32s ease';
            featImg.style.opacity    = '1';
          }
          if (featInfo) {
            featInfo.style.transition = 'opacity .32s ease, transform .32s cubic-bezier(.25,.46,.45,.94)';
            featInfo.style.opacity    = '1';
            featInfo.style.transform  = 'translateX(0)';
          }
        }, 200);
      }

      /* ── Navigate to index ── */
      function goTo(idx, direction) {
        var dir = (direction !== undefined) ? direction : (idx >= current ? 1 : -1);
        current = Math.max(0, Math.min(total - 1, idx));
        updateFeatured(current, dir);
        showRightCards(dir);

        // Progress bar: 0% at start → 100% when last card is visible in right panel
        var maxCurrent = Math.max(1, total - 4);
        if (fill) fill.style.width = (total <= 4 ? 100 : Math.min(100, (current / maxCurrent) * 100)) + '%';

        // Hard stops: prev at first; next when last product is already in the right panel
        if (prevBtn) prevBtn.disabled = (current === 0);
        if (nextBtn) nextBtn.disabled = (current + 3 >= total - 1);
      }

      // Initialise without animation
      goTo(0, 0);

      if (prevBtn) prevBtn.addEventListener('click', function () { goTo(current - 1, -1); });
      if (nextBtn) nextBtn.addEventListener('click', function () { goTo(current + 1,  1); });

      // Desktop: clicking a right card makes it the featured product
      cards.forEach(function (card, i) {
        card.addEventListener('click', function (e) {
          if (window.innerWidth >= 768) {
            e.preventDefault();
            goTo(i, i > current ? 1 : -1);
          }
        });
      });

      // Re-apply show/hide on resize (no animation)
      var resizeTimer;
      window.addEventListener('resize', function () {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(function () { showRightCards(0); }, 120);
      });
    });
  }

  /* ============================================================
     PRODUCT PAGE
  ============================================================ */
  var SWATCH_COLORS = {
    'white': '#FFFFFF', 'black': '#111111', 'grey': '#9CA3AF', 'gray': '#9CA3AF',
    'silver': '#C0C0C0', 'cream': '#FFF8DC', 'ivory': '#FFFFF0', 'beige': '#F5F5DC',
    'sand': '#C2B280', 'tan': '#D2B48C', 'brown': '#8B4513', 'taupe': '#483C32',
    'charcoal': '#374151', 'navy': '#1E3A5F', 'blue': '#3B82F6', 'sky-blue': '#7DD3FC',
    'teal': '#0D9488', 'green': '#22C55E', 'olive': '#6B7280', 'sage': '#87A878',
    'mint': '#98FF98', 'yellow': '#FACC15', 'gold': '#D4AF37', 'orange': '#F97316',
    'coral': '#FF6B6B', 'red': '#EF4444', 'rose': '#FB7185', 'pink': '#EC4899',
    'blush': '#FFB6C1', 'lavender': '#C8B8DB', 'purple': '#8B5CF6', 'mauve': '#E0B0FF',
    'lilac': '#DDA0DD', 'maroon': '#800000', 'burgundy': '#800020',
    'everyday': '#D2B48C', 'limited-edition': '#B8860B'
  };

  function initProductPage() {
    var section = document.querySelector('.k-product-section');
    if (!section) return;

    /* --- Custom swatch colour map from blocks --- */
    var swatchMapEl = document.getElementById('k-swatch-map');
    var customSwatchColors = {};
    if (swatchMapEl) {
      try { customSwatchColors = JSON.parse(swatchMapEl.textContent); } catch (e) {}
    }

    /* --- Main product variants --- */
    var variantsEl = document.getElementById('k-variants-data');
    if (!variantsEl) return;
    var variants;
    try { variants = JSON.parse(variantsEl.textContent); } catch (e) { return; }

    var variantIdInput = document.getElementById('k-variant-id');
    var priceEl        = document.getElementById('k-product-price');
    var stockEl        = document.getElementById('k-product-stock');
    var atcBtn         = document.getElementById('k-atc-btn');
    var stickyBar      = document.getElementById('k-product-sticky-bar');
    var stickyAtcBtn   = document.getElementById('k-sticky-atc-btn');
    var stickyPrice    = document.getElementById('k-sticky-price');
    var installmentEl  = document.getElementById('k-payment-installment');

    var atcButtonText  = atcBtn ? atcBtn.textContent.trim() : 'Add to Cart';
    var soldOutText    = 'Sold Out';

    /* --- Selected option state for main product --- */
    var selectedOpts = {};
    section.querySelectorAll('.k-product-options .k-product-option').forEach(function (opt) {
      var idx   = parseInt(opt.dataset.optionIndex, 10);
      var first = opt.querySelector('.k-swatch.active, .k-pill.active');
      if (first) selectedOpts[idx] = first.dataset.value;
    });

    function findVariant() {
      return variants.find(function (v) {
        if (selectedOpts[0] !== undefined && v.option1 !== selectedOpts[0]) return false;
        if (selectedOpts[1] !== undefined && v.option2 !== selectedOpts[1]) return false;
        if (selectedOpts[2] !== undefined && v.option3 !== selectedOpts[2]) return false;
        return true;
      }) || null;
    }

    function moneyFormat(cents) {
      return '$' + (cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    }

    function applyVariant(v) {
      if (!v) return;
      variantIdInput.value = v.id;
      var money = moneyFormat(v.price);
      if (priceEl) priceEl.textContent = money;
      if (stickyPrice) stickyPrice.textContent = money;
      if (stickyAtcBtn) stickyAtcBtn.textContent = atcButtonText + ' — ' + money;
      if (installmentEl) installmentEl.textContent = moneyFormat(Math.round(v.price / 4));
      if (atcBtn) {
        atcBtn.disabled = !v.available;
        atcBtn.setAttribute('aria-disabled', String(!v.available));
        atcBtn.textContent = v.available ? atcButtonText : soldOutText;
      }
      if (stockEl) {
        stockEl.innerHTML = v.available
          ? '<span class="k-stock-dot k-stock-in" aria-hidden="true"></span>In stock'
          : '<span class="k-stock-dot k-stock-out" aria-hidden="true"></span>Out of stock';
      }
      if (v.image) {
        var track = document.getElementById('k-img-track');
        if (track) {
          var firstSlide = track.querySelector('.k-product-img-slide');
          if (firstSlide) {
            var firstImg = firstSlide.querySelector('img');
            if (firstImg && firstImg.src !== v.image) {
              firstImg.src = v.image;
              goTo(0);
            }
          }
        }
      }
    }

    /* --- Swatch colours: custom map overrides built-in SWATCH_COLORS --- */
    function resolveSwatchColor(swatchEl) {
      var exactValue = swatchEl.dataset.value || '';
      var hyphenKey  = (swatchEl.dataset.color || '').toLowerCase();
      return customSwatchColors[exactValue]
          || SWATCH_COLORS[hyphenKey]
          || null;
    }

    function applySwatchColors(root) {
      (root || section).querySelectorAll('.k-swatch').forEach(function (sw) {
        var hex = resolveSwatchColor(sw);
        if (hex) {
          sw.style.backgroundColor = hex;
          sw.style.backgroundImage = '';
        } else {
          sw.style.backgroundColor = '#E5E7EB';
          sw.style.backgroundImage = 'linear-gradient(135deg,#E5E7EB 50%,#D1D5DB 50%)';
        }
      });
    }
    applySwatchColors();

    /* --- Main product option selector clicks --- */
    section.addEventListener('click', function (e) {
      /* qty buttons */
      var qtyBtn = e.target.closest('[data-qty]');
      if (qtyBtn) {
        if (qtyBtn.dataset.qty === 'plus') qty++;
        if (qtyBtn.dataset.qty === 'minus' && qty > 1) qty--;
        if (qtyDisplay) qtyDisplay.textContent = qty;
        if (qtyInput) qtyInput.value = qty;
        return;
      }

      var btn = e.target.closest('.k-swatch, .k-pill');
      if (!btn) return;

      /* ── Promo block variant selection ── */
      var promoProduct = btn.closest('.k-promo-product');
      if (promoProduct) {
        var blockId   = promoProduct.dataset.blockId;
        var promoOpt  = btn.closest('.k-promo-option');
        if (!promoOpt) return;
        var oIdx = parseInt(promoOpt.dataset.optionIndex, 10);

        promoOpt.querySelectorAll('.k-swatch, .k-pill').forEach(function (b) {
          b.classList.remove('active'); b.setAttribute('aria-checked', 'false');
        });
        btn.classList.add('active'); btn.setAttribute('aria-checked', 'true');

        var oval = promoOpt.querySelector('.k-option-selected-val');
        if (oval) oval.textContent = btn.dataset.value || btn.textContent.trim();

        /* collect all promo options */
        var promoOpts = {};
        promoProduct.querySelectorAll('.k-promo-option').forEach(function (po) {
          var active = po.querySelector('.k-swatch.active, .k-pill.active');
          if (active) promoOpts[parseInt(po.dataset.optionIndex, 10)] = active.dataset.value;
        });

        var promoVarEl = document.getElementById('k-promo-v-' + blockId);
        if (promoVarEl) {
          var pv;
          try { pv = JSON.parse(promoVarEl.textContent); } catch (ex) {}
          if (pv) {
            var matched = pv.find(function (v) {
              if (promoOpts[0] !== undefined && v.option1 !== promoOpts[0]) return false;
              if (promoOpts[1] !== undefined && v.option2 !== promoOpts[1]) return false;
              if (promoOpts[2] !== undefined && v.option3 !== promoOpts[2]) return false;
              return true;
            });
            if (matched) {
              var priceEl2 = document.getElementById('k-promo-price-' + blockId);
              if (priceEl2) priceEl2.textContent = moneyFormat(matched.price);
              var promoAtcBtn = section.querySelector('.k-promo-atc-btn[data-block-id="' + blockId + '"]');
              if (promoAtcBtn) promoAtcBtn.dataset.promoVariant = matched.id;
            }
          }
        }
        return;
      }

      /* ── Main product option selection ── */
      var opt = btn.closest('.k-product-options .k-product-option');
      if (!opt) return;
      var idx = parseInt(opt.dataset.optionIndex, 10);
      opt.querySelectorAll('.k-swatch, .k-pill').forEach(function (b) {
        b.classList.remove('active'); b.setAttribute('aria-checked', 'false');
      });
      btn.classList.add('active'); btn.setAttribute('aria-checked', 'true');
      selectedOpts[idx] = btn.dataset.value;
      var valLabel = opt.querySelector('.k-option-selected-val');
      if (valLabel) valLabel.textContent = btn.dataset.value || btn.textContent.trim();
      applyVariant(findVariant());
    });

    /* --- Gallery --- */
    var track      = document.getElementById('k-img-track');
    var prevBtn    = document.getElementById('k-gallery-prev');
    var nextBtn    = document.getElementById('k-gallery-next');
    var thumbsWrap = document.getElementById('k-product-thumbs');
    var currentIdx = 0;
    var slides     = track ? Array.from(track.querySelectorAll('.k-product-img-slide')) : [];

    function slideWidth() { return slides[0] ? slides[0].offsetWidth + 8 : 0; }

    function goTo(idx) {
      if (!slides.length) return;
      idx = Math.max(0, Math.min(idx, slides.length - 1));
      currentIdx = idx;
      track.style.transform = 'translateX(-' + (idx * slideWidth()) + 'px)';
      if (prevBtn) prevBtn.disabled = idx === 0;
      if (nextBtn) nextBtn.disabled = idx >= slides.length - 1;
      if (thumbsWrap) {
        thumbsWrap.querySelectorAll('.k-product-thumb').forEach(function (t) {
          t.classList.toggle('active', parseInt(t.dataset.index, 10) === idx);
        });
      }
    }
    if (prevBtn) prevBtn.addEventListener('click', function () { goTo(currentIdx - 1); });
    if (nextBtn) nextBtn.addEventListener('click', function () { goTo(currentIdx + 1); });
    if (thumbsWrap) {
      thumbsWrap.addEventListener('click', function (e) {
        var th = e.target.closest('.k-product-thumb');
        if (th) goTo(parseInt(th.dataset.index, 10));
      });
    }
    var wrap = document.getElementById('k-images-wrap');
    if (wrap && track) {
      var dragStartX = 0, dragging = false;
      wrap.addEventListener('touchstart', function (e) { dragStartX = e.touches[0].clientX; dragging = true; }, { passive: true });
      wrap.addEventListener('touchend', function (e) {
        if (!dragging) return; dragging = false;
        var dx = e.changedTouches[0].clientX - dragStartX;
        if (Math.abs(dx) > 40) goTo(dx < 0 ? currentIdx + 1 : currentIdx - 1);
      }, { passive: true });
    }

    /* --- Quantity controls --- */
    var qtyDisplay = document.getElementById('k-prod-qty-display');
    var qtyInput   = document.getElementById('k-prod-qty-input');
    var qty = 1;

    /* --- Main ATC form --- */
    var form = document.getElementById('k-product-form');
    if (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var vid = variantIdInput ? parseInt(variantIdInput.value, 10) : 0;
        if (!vid) return;
        var submitBtn = form.querySelector('[type="submit"]');
        if (submitBtn) { submitBtn.disabled = true; submitBtn.textContent = 'Adding…'; }
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ id: vid, quantity: qtyInput ? parseInt(qtyInput.value, 10) : 1 })
        }).then(function (r) { return r.json(); })
          .then(function () { if (typeof window._kraunoRenderCart === 'function') window._kraunoRenderCart(); })
          .catch(function (err) { console.error('Cart add failed:', err); })
          .finally(function () { if (submitBtn) { submitBtn.disabled = false; submitBtn.textContent = atcButtonText; } });
      });
    }

    /* --- Sticky ATC --- */
    if (stickyAtcBtn) {
      stickyAtcBtn.addEventListener('click', function () {
        var vid = variantIdInput ? parseInt(variantIdInput.value, 10) : 0;
        if (!vid) return;
        stickyAtcBtn.disabled = true;
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ id: vid, quantity: qty })
        }).then(function (r) { return r.json(); })
          .then(function () { if (typeof window._kraunoRenderCart === 'function') window._kraunoRenderCart(); })
          .catch(function (err) { console.error('Sticky cart failed:', err); })
          .finally(function () { stickyAtcBtn.disabled = false; });
      });
    }

    /* --- Promo block ATC (supports BOGO) --- */
    section.addEventListener('click', function (e) {
      var promoBtn = e.target.closest('.k-promo-atc-btn');
      if (!promoBtn) return;
      var promoVarId = parseInt(promoBtn.dataset.promoVariant, 10);
      var isBogo     = promoBtn.dataset.bundle === 'true';
      var items = [];
      if (promoVarId) items.push({ id: promoVarId, quantity: 1 });
      if (isBogo && variantIdInput) {
        var mainId = parseInt(variantIdInput.value, 10);
        if (mainId) items.unshift({ id: mainId, quantity: qty });
      }
      if (!items.length) return;
      var origText = promoBtn.textContent;
      promoBtn.disabled = true; promoBtn.textContent = 'Adding…';
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: items })
      }).then(function (r) { return r.json(); })
        .then(function () { if (typeof window._kraunoRenderCart === 'function') window._kraunoRenderCart(); })
        .catch(function (err) { console.error('Promo cart failed:', err); })
        .finally(function () { promoBtn.disabled = false; promoBtn.textContent = origText; });
    });

    /* --- Sticky bar: show when ATC scrolls out of view above --- */
    var atcAnchor = document.getElementById('k-atc-anchor');
    if (atcAnchor && stickyBar && 'IntersectionObserver' in window) {
      var stickyObs = new IntersectionObserver(function (entries) {
        var entry = entries[0];
        var show = !entry.isIntersecting && entry.boundingClientRect.top < 0;
        stickyBar.classList.toggle('visible', show);
        stickyBar.setAttribute('aria-hidden', String(!show));
      }, { threshold: 0 });
      stickyObs.observe(atcAnchor);
    }

    /* --- Mobile image dots: sync active dot on scroll --- */
    var imagesWrap = document.getElementById('k-images-wrap');
    var imgDotsEl  = document.getElementById('k-img-dots');
    if (imagesWrap && imgDotsEl) {
      var imgDotEls = imgDotsEl.querySelectorAll('.k-img-dot');
      imagesWrap.addEventListener('scroll', function () {
        var idx = Math.round(imagesWrap.scrollLeft / imagesWrap.offsetWidth);
        imgDotEls.forEach(function (d, i) { d.classList.toggle('active', i === idx); });
      }, { passive: true });
    }

    /* --- Feature icons carousel --- */
    var featTrack = document.getElementById('k-features-track');
    var featFill  = document.getElementById('k-features-fill');
    var featNext  = document.getElementById('k-features-next');
    var featPrev  = document.getElementById('k-features-prev');
    if (featTrack) {
      function syncFeat() {
        if (featFill) {
          var max = featTrack.scrollWidth - featTrack.clientWidth;
          featFill.style.width = (max > 0 ? Math.min(featTrack.scrollLeft / max * 100, 100) : 100) + '%';
        }
        if (featPrev) featPrev.disabled = featTrack.scrollLeft <= 0;
        if (featNext) featNext.disabled = featTrack.scrollLeft >= featTrack.scrollWidth - featTrack.clientWidth - 1;
      }
      if (featNext) featNext.addEventListener('click', function () {
        var card = featTrack.querySelector('.k-product-feature');
        if (card) featTrack.scrollBy({ left: card.offsetWidth, behavior: 'smooth' });
      });
      if (featPrev) featPrev.addEventListener('click', function () {
        var card = featTrack.querySelector('.k-product-feature');
        if (card) featTrack.scrollBy({ left: -card.offsetWidth, behavior: 'smooth' });
      });
      featTrack.addEventListener('scroll', syncFeat, { passive: true });
      syncFeat();
    }

    /* --- Accordions --- */
    section.querySelectorAll('.k-accordion-trigger').forEach(function (trigger) {
      trigger.addEventListener('click', function () {
        var expanded  = this.getAttribute('aria-expanded') === 'true';
        var contentEl = document.getElementById(this.getAttribute('aria-controls'));
        this.setAttribute('aria-expanded', String(!expanded));
        if (contentEl) {
          if (expanded) contentEl.setAttribute('hidden', '');
          else          contentEl.removeAttribute('hidden');
        }
      });
    });
  }

  /* ============================================================
     COMPLEMENTARY PRODUCTS
  ============================================================ */
  function initComplementaryProducts() {
    var row      = document.getElementById('k-compl-row');
    var fill     = document.getElementById('k-compl-fill');
    var nextBtn  = document.getElementById('k-compl-next');
    if (!row) return;

    function syncProg() {
      if (!fill) return;
      var maxScroll = row.scrollWidth - row.clientWidth;
      var pct = maxScroll > 0 ? (row.scrollLeft / maxScroll) * 100 : 0;
      fill.style.width = Math.min(pct, 100) + '%';
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        var card = row.querySelector('.k-compl-card');
        if (card) row.scrollBy({ left: card.offsetWidth + 16, behavior: 'smooth' });
      });
    }
    row.addEventListener('scroll', syncProg, { passive: true });
    syncProg();
  }

  /* ============================================================
     BOOT
  ============================================================ */
  document.addEventListener('DOMContentLoaded', function () {
    updateModeUI(getMode());

    initHeader();
    initMobileMenu();
    initMobileSubmenus();
    initDropdowns();
    initModeToggle();
    initScrollAnimations();
    initStatsCounters();
    initHotspots();
    initCarouselDots();
    initHeroCTA();
    initSearch();
    initAccountPanel();
    initCartDrawer();
    initAddToCart();
    initProductCatalogs();
    initProductPage();
    initComplementaryProducts();
  });

  /* ============================================================
     SHOPIFY THEME EDITOR — re-init when sections/blocks change
  ============================================================ */
  document.addEventListener('shopify:section:load', function () {
    makeAllVisible();
    initMobileSubmenus();
    initDropdowns();
    initModeToggle();
    initHotspots();
    initCarouselDots();
    initProductCatalogs();
    initHeroCTA();
    initStatsCounters();
    initSearch();
    initAccountPanel();
    initCartDrawer();
    initProductPage();
    initComplementaryProducts();
  });

  document.addEventListener('shopify:section:reorder', function () {
    makeAllVisible();
  });

  document.addEventListener('shopify:block:select', function (event) {
    var el = event.target;
    if (!el) return;
    el.classList.add('visible');
    el.querySelectorAll('.k-product-card, .k-stat-card, .k-trust-item, .k-room-canvas').forEach(function (child) {
      child.classList.add('visible');
    });
  });

})();
